<template>
  <lsSearchForm
    ref="lsSearchForm"
    @search="handleSearch"
    :initExpand="false"
    :formList="formList"
    :searchContentFold="false"
  >
    <lsSelectPage
      v-for="item in formList.filter(item => item.customType === 'render_pageSelect')"
      :key="item.decorator[0]"
      v-decorator="item.decorator"
      :datas="item.options"
      placeholder="请选择"
      :slot="`${item.decorator[0]}`"
      searchKey="label"
      valueKey="value"
    >
      <template slot="select-option" slot-scope="{items}">
        <a-select-option
          v-for="option in items"
          :key="option.value"
        >
          {{ option.label }}
        </a-select-option>
      </template>
    </lsSelectPage>
  </lsSearchForm>
</template>

<script>
export default {
  name: "ListSearchForm",
  components: { },
  props: { },
  data () {
    return {
      formData: {},
      formList: [
        {
          label: "角色名称",
          type: "input",
          decorator: ["roleName"],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "权限字符",
          type: "input",
          decorator: ["roleKey"],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "状态",
          type: "select",
          decorator: ["status"],
          options: [
            { key: 0, value: "正常" },
            { key: 1, value: "禁用" }
          ],
          attrs: {
            placeholder: "请选择"
          }
        },
        {
            label: "创建时间",
            type: "range",
            decorator: ["dataCreate"],
            disposeFormat: {
                beginTime: (change) => {
                    return change[0].format('yyyy-MM-DD')
                },
                endTime: (change) => {
                    return change[1].format('yyyy-MM-DD')
                }
            }
        }
      ]
    };
  },
  methods: {
    handleSearch (values) {
      if (values) {
        delete values.searchFormLabel
      }
      if (values.beginTime) {
        values.params = {};
        values.params['beginTime'] = values.beginTime;
        values.params['endTime'] = values.endTime;
      }
      delete values.beginTime;
      delete values.endTime;
      this.$emit("onSearch", values);
    },
    handleFormSearch () {
      this.$refs.lsSearchForm.handleSearch();
    }
  }
};
</script>

<style scoped></style>
